/**
 * Returns true if the element is a valid date
 * @public
 *
 * @param arg - A generic argument to check
 *
 * @returns A boolean indicating whether the arg is a valid Date or not.
 *
 * @example
 * ```ts
 * const result = isValidDate(new Date());
 * console.log(result);
 * // -> true
 * ```
 * */
function isValidDate<T>(arg: unknown): arg is T {
  return arg instanceof Date && !Number.isNaN(arg.getTime());
}

export { isValidDate };
